class HeaderMenu extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        const details = this.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
  }
}

customElements.define('header-menu', HeaderMenu);

document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
  const hero = slider.closest('.hero');
  const slides = [...slider.querySelectorAll('[data-hero-slide]')];
  const dots = hero ? [...hero.querySelectorAll('[data-hero-dot]')] : [];

  if (slides.length <= 1) return;

  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;

  const showSlide = (nextIndex) => {
    activeIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => showSlide(index));
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    window.setInterval(() => showSlide(activeIndex + 1), 5200);
  }
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-product-media-track]');
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
  const prevButton = gallery.querySelector('[data-product-gallery-prev]');
  const nextButton = gallery.querySelector('[data-product-gallery-next]');

  if (!track || slides.length <= 1) return;

  let activeIndex = 0;
  let scrollFrame;

  const setActive = (index, shouldScroll) => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    if (shouldScroll) {
      slides[activeIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  };

  const updateActiveFromScroll = () => {
    const trackLeft = track.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    setActive(closestIndex, false);
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      setActive(Number(thumb.dataset.productTarget || 0), true);
    });
  });

  prevButton?.addEventListener('click', () => {
    setActive(activeIndex - 1, true);
  });

  nextButton?.addEventListener('click', () => {
    setActive(activeIndex + 1, true);
  });

  track.addEventListener('scroll', () => {
    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(updateActiveFromScroll);
  }, { passive: true });
});

document.querySelectorAll('[data-quantity-step]').forEach((button) => {
  button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;

    const step = Number(button.dataset.quantityStep);
    const min = Number(input.min || 1);
    const next = Math.max(min, Number(input.value || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
